import React from 'react'

function UpdatesCard({ item }) {
    return (
        <>
            <div className="d-flex flex-column align-items-center">
                {item.Data?.ImageLink?.data && (
                    <img
                        src={item.Data.ImageLink.data}
                        alt="Update"
                        className="img-fluid rounded"
                        style={{ maxWidth: '100%' }}
                    />
                )}
            </div>
            <p className="text-center mt-3">{item?.Data?.Title || 'Update'}</p>
        </>
    )
}

export default UpdatesCard